import Image from "next/image"
import Link from "next/link"
const { DateTime } = require("luxon");
import { supabase } from "../../utils/supabaseClient"
import { Check } from "react-bootstrap-icons"
import { cloudfront, features, burnoutFeatures } from "../../config"
import Layout from '../../components/Layouts/homeLayout'
import { useAuth, AuthProvider } from "../../contexts/Auth"
import AlertTemplate from '../../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import Meta from "../../components/Meta";

export async function getStaticPaths() {
    const {data, error} = await supabase
      .from('main_article')
      .select('slug')
      .eq("status", "live")
    
    error && console.log(error)
      
    const paths = data.map((obj) => ({ params: { slug: obj.slug }}))
    return {
      paths,
      fallback: 'blocking'
    }
  }
  
  export async function getStaticProps(context) {
      //the article
      const {data, error} = await supabase
        .from('main_article')
        .select('*, profile(name, user_image)')
        .match({slug: context.params.slug})

      error && console.log(error)

      const article = data[0]

    return {
        props: {
            article
        }
        //revalidate ??
    }
  }

export default function Article({article}) {
    return (
        <div className="bg-slate-200/50 h-full pt-5">
          <Meta
               title={article.title}
               description={article.content.substring(0,200).replace(/<[^>]*>?/gm, '')}
          />
          <div className="lg:px-64 md:px-40  text-left overflow-hidden py-10 flex flex-col items-baseline bg-slate-200/80 ">
            <div className="sm:mx-10  mx-10 ">
              {article.cover_image && 
                    <div className="">

                          <Image
                          src={"https://d28zq0um2frnpx.cloudfront.net/media/article_images/" + article.cover_image}
                          height={300}
                          width={1000}
                          alt={article.cover_image_alt}
                          className={"rounded-lg"}
                          objectFit="cover"
                      />
                      </div>
              }

     
            <p className="text-slate-500 mb-0">{DateTime.fromISO(article.date_published).toFormat("DDD")}</p>
            <h1 className="font-extrabold text-4xl text-slate-800 ">{article.title}</h1>
            <div className="flex items-center space-x-2 mt-1">
                <Image
                    src={"https://d28zq0um2frnpx.cloudfront.net/" + article.profile.user_image}
                    height={30}
                    width={30}
                    className="rounded-full"
                    objectFit="cover"
                />
                <p className="text-slate-600 text-md font-semibold">James Schwindt</p>
               
            </div>
            <div className="text-slate-500 text-sm italic font-semibold w-2/3">Building software and coaching to help individuals monetize their knowledge and experience. Founder of Plaza, OrdinaryCoders</div>
            </div>
          </div>
          <div>
            {/* //Cover image here */}
          </div>
          <div className="absolute  h-full w-full overflow-hidden z-0" aria-hidden="true">
          <div className="relative h-full overflow-hidden">
            <svg
              className="absolute right-full transform translate-y-1/3 translate-x-1/4 md:translate-y-1/2 sm:translate-x-1/2 lg:translate-x-full"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="e229dbec-10e9-49ee-8ec3-0286ca089edf"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={784} fill="url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)" />
            </svg>
            <svg
              className="absolute left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="d2a68204-c383-44b1-b99f-42ccff4e5365"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={784} fill="url(#d2a68204-c383-44b1-b99f-42ccff4e5365)" />
            </svg>
            
            
          </div>
        </div>
          <div className="md:mx-40 lg:mx-64  text-left pb-48 z-20 relative">
            
            <div className="space-y-12 sm:px-10 mx-10 sm:mx-5 md:mx-auto">
                <div className="text-slate-800 text-lg" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: article.content}}/>
            </div>

              {/* CTA */}
              {article.type === "saas" &&
                    <div className="bg-white rounded-lg shadow-lg mt-20 border flex flex-col sm:flex-row justify-between">
                    <div className="p-10 shadow z-10 w-full sm:w-[60%] text-center">
                    <h2 className="text-slate-800 font-bold text-2xl">Get started today with Plaza</h2>
                      <p className="text-slate-800">Everything you need for your virtual coaching business</p>
                      <div className="flex space-x-3 mt-4 mx-auto w-72 ">
                        <Link href="/">
                        <a
                        className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700"
                        >Get Started</a>
                      </Link>
                      <Link href="/">
                        <a
                        className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-slate-700 text-white shadow-lg shadow-slate-500/50 bg-slate-600"
                        >Book a Demo</a>
                      </Link>
      
                      </div>
                      <div className="my-2 mx-auto text-center">
          
                      <Image
                           objectFit={'contain'}
                           src={`${cloudfront}/static/branding_group.png`}
                           width={500}
                           height={300}
                           alt="Plaza for video consultations"
                       
                       />
                        </div>
                    </div>
                    <div className="space-y-5 p-10 bg-slate-100 w-full sm:w-[40%]">
                      {features.map(string => (
                        <div key={string} className="flex justify-start items-center space-x-4">
                          <div className=""><Check className="bg-green-400 text-white rounded-full"/></div>
                          <p className="text-slate-700 font-semibold"  key={string}>{string}</p>
                        </div>
                      ))}
                    </div>
             
                  </div>
              
              }
              {article.type === "burnout" && 
              
              <div className="bg-white rounded-lg shadow-lg mt-20 border flex flex-col sm:flex-row justify-between">
              <div className="p-10 shadow z-10 w-full sm:w-[60%] text-center">
              <h2 className="text-slate-800 font-bold text-2xl">Get started today with Burnout Coaching</h2>
                <p className="text-slate-800">Book a free discovery call with a certified coach</p>
                <div className="flex justify-center space-x-3 mt-4 mx-auto w-72 ">
                  <Link href="/services/burnout">
                  <a
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700"
                  >Get Started</a>
                </Link>

                </div>
                <div className="my-2 mx-auto text-center">
    
                <Image
                     objectFit={'contain'}
                     src={`${cloudfront}/static/branding_group.png`}
                     width={500}
                     height={300}
                     alt="Plaza for video consultations"
                 
                 />
                  </div>
              </div>
              <div className="space-y-5 p-10 bg-slate-100 w-full sm:w-[40%]">
                {burnoutFeatures.map(string => (
                  <div key={string} className="flex justify-start items-center space-x-4">
                    <div className=""><Check className="bg-green-400 text-white rounded-full"/></div>
                    <p className="text-slate-700 font-semibold"  key={string}>{string}</p>
                  </div>
                ))}
              </div>
       
            </div>
              
              
              }
      
          </div>
          <div className="w-full flex justify-center">
            <p className="text-slate-500">© 2023 Ordinary Media, LLC. All Rights Reserved.</p>

          </div>
          <style jsx global>{`
p > a {
  text-decoration:underline;
}
p > a:hover {
  color: rgb(23, 40, 70);
}
p {
  margin-top:20px;
  margin-bottom:20px;
  color:rgb(71 85 105);
}
h1 {
  font-size: 2em;
}

h2 {
  font-size: 1.5em;
  margin-top: 40px;
  margin-bottom:5px;
}
h3 {
  font-size: 1.17em;
  margin-top:40px;
  margin-bottom:5px;
}

h4 {
  font-size: 1em;
}
.ProseMirror ul, .ProseMirror ol {
  padding: 0 2rem;
}

ol, menu {
  list-style: auto;
  margin: 0;
  padding: 0;
}


 ul, menu {
  list-style: inherit;
  margin: 0;
  padding: 0;
  padding-left:60px;
}


`}</style>
        </div>
    );
}

const alertOptions = {
    // you can also just use 'bottom right'
    position: positions.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: {'zIndex':'9999'},
    // you can also just use 'fade'
    transition: transitions.FADE,
  }
  
  Article.getLayout = function getLayout(page) {
    return (
        <AlertProvider template={AlertTemplate} {...alertOptions}>
            <AuthProvider>
                <Layout>
                    {page}
                </Layout>
            </AuthProvider>
        </AlertProvider>
    )
  }
  
